import { thingService } from '@/services/thing.service'
import { mapActions } from 'vuex'
import { DialogRuses } from "@/tools/dialog"
import { EventHub } from "@/constants/constants"

export default {
    name: 'EnterpriseRusesTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
        update: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        loadingEventTypes: false,
        loadingStateTypes: false,
        thingTypes: [],
        filteredThingTypes: [],
        ruses: [],
        rusKeys: [],
        validRusConfiguration: {},
        thingTypeFilter: null
    }),
    computed: {
    },
    created () {
        // Evento lanzado por el diálogo de creación de línea, cuando se guarda la nueva línea
        this.$eventBus.$on(EventHub.COMMIT_RUS_CONFIGURATION, (rusConfiguration) => {
            this.updateRusConfiguration(rusConfiguration)
        })
    },
    mounted () {
        this.getTypes()
        this.getRuses()
        this.getRusKeys()
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        getTypes () {
            thingService.getTypesForSelector().then(response => {
                this.thingTypes.push(...response)
                this.filteredThingTypes.push(...response)
                this.getValidRusConfiguration()
            })
        },
        getRuses () {
            thingService.getRuses().then(response => {
                this.ruses.push(...response)
            })
        },
        getRusKeys () {
            thingService.getRusKeys().then(response => {
                this.rusKeys.push(...response)
            })
        },
        getValidRusConfiguration () {
            this.thingTypes.forEach(type => {
                const valid = !!this.model.ruses[type._id]
                this.validRusConfiguration[type._id] = {
                    tooltip: valid ? this.$t('enterprise.rusDialog.valid') : this.$t('enterprise.rusDialog.warning'),
                    icon: valid ? 'mdi-check-circle' : 'mdi-alert-circle',
                    color: valid ? 'success' : 'warning',
                }
            })
        },
        /**
         * Abre el dialog para editar la configuración de ruses para cada tipo de cosa
         * @param {*} level
         * @param {*} view
         */
        openRusDialog (typeId, type) {
            const bread = {
                key: DialogRuses,
                disabled: true,
                text: this.$t('ruses.name'),
                model: {
                    rusConfigurations: this.model.ruses[typeId] || {},
                    ruses: this.ruses,
                    rusKeys: this.rusKeys,
                    type,
                    typeId
                },
                update: this.update
            }
            this.pushBread(bread)
        },
        /**
         * Luego de guardar la configuración de rus en el dialog, actualizo los valores en el modelo
         * @param {*} rusConfiguration
         */
        updateRusConfiguration (rusConfiguration) {
            this.model.ruses[rusConfiguration.typeId] = rusConfiguration.rusConfigurations
            const valid = !!this.model.ruses[rusConfiguration.typeId]
            this.validRusConfiguration[rusConfiguration.typeId] = {
                tooltip: valid ? this.$t('enterprise.rusDialog.valid') : this.$t('enterprise.rusDialog.warning'),
                icon: valid ? 'mdi-check-circle' : 'mdi-alert-circle',
                color: valid ? 'success' : 'warning',
            }
        },
        filterThingTypes () {
            if (this.thingTypeFilter) {
                this.filteredThingTypes = this.thingTypes.filter(t => t.name.toLowerCase().includes(this.thingTypeFilter.toLowerCase()))
            } else {
                this.filteredThingTypes.cleanAndUpdate(this.thingTypes)
            }
        }
    }
}
